"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFuelAccountNumberFormat = function (value) {
    // value can be undefined from formik if initial value is ""
    return new RegExp("^\\d{11}$").test(value);
};
//# sourceMappingURL=isFuelAccountNumberFormat.js.map